// 全画面共通のCSS。読み込み順はReact版のproductionビルドに合わせている
import "./styles/ress.css"
import "./styles/app.scss"
import "./styles/layout.scss"
import "./styles/media.scss"
import "./styles/footer.scss"
import "./styles/modal.scss"

import { createApp } from "vue"
import App from "./App.vue"
import router from "./router"
import vuetify from "./plugins/vuetify"

createApp(App).use(router).use(vuetify).mount("#app")
